import React, { Component } from "react";
import {View, Image, TouchableOpacity, Linking} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor} from "../theme/colors";
import Waiting from "../components/Waiting";
import DialogList from "../components/DialogList";
import DialogMessage from "../components/DialogMessage";

export default class CurrentOrderScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            sections: [],
            selectedSection: null,
            content: '',
            waiting: false,
            sectionModal: false,
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSucces: false
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>یافتن سفیر سلامت</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={settingStyles.wraper}>
                <TextView style={{ textAlign: 'center', color: 'white' }}>در حال یافتن نزدیک ترین سفیر سلامت</TextView>

                <Waiting waiting={this.state.waiting} />
            </LinearGradient>
            <DialogList
                show={this.state.sectionModal}
                title='انتخاب بخش'
                field='name'
                data={this.state.sections}
                onSelect={(item, index) => {
                    this.setState({
                        sectionModal: false,
                        selectedSection: item,
                    })

                }}
                onCancel={() => {
                    this.setState({
                        sectionModal: false
                    })
                }} />
            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    })
                    if (this.state.messageSucces) {
                        this.props.navigation.goBack()
                    }
                }} />
        </View>)
    }


    componentWillUnmount() {
        Linking.openURL('https://client.asandarman.ir');
    }

}
